const admins = ["admin", "fin_admin"];
const editors = ["editor", "advanced"].concat(admins);
const everyone = ["viewer", "partner", "auditor"].concat(editors);

const permissions = {
  invoices: {
    index: everyone,
    new: editors,
    edit: editors,
    delete: admins,
  },
  // FIN-1281: the import queue — read by everybody who reads invoices except partners,
  // acted on by the editors (their own orders, on the server) and accounting.
  invoice_imports: {
    index: ["viewer", "auditor"].concat(editors),
    new: editors,
    edit: editors,
    delete: admins,
  },
  profile: {
    index: everyone,
    new: [],
    edit: everyone,
    delete: [],
  },
  requisition_lists: {
    index: everyone,
    new: editors,
    edit: editors,
    delete: editors,
  },
  banks: {
    index: editors,
    new: editors,
    edit: editors,
    delete: admins,
  },
  companies: {
    index: editors,
    new: editors,
    edit: editors,
    delete: admins,
  },
  purchase_orders: {
    index: everyone,
    new: editors,
    edit: editors,
    delete: admins,
  },
  payment_instructions: {
    index: everyone,
    new: editors,
    edit: editors,
    delete: admins,
  },
  delivery_notes: {
    index: everyone,
    new: editors,
    edit: editors,
    delete: admins,
  },
  service_fees: {
    index: everyone,
    new: editors,
    edit: editors,
    delete: admins,
  },
  companies_balance: {
    index: admins,
    new: admins,
    edit: admins,
    delete: admins,
  },
  partner_schemes: {
    index: admins,
    new: admins,
    edit: admins,
    delete: admins,
  },
  payrolls: {
    index: editors,
    new: editors,
    edit: editors,
    delete: admins,
  },
  // The Master Account months DAX publishes (FIN-1263). Read-only by nature —
  // the statement belongs to the ship — so `new`, `edit` and `delete` are
  // nobody's: what the page writes is the month's own documents, and those are
  // governed by the permissions of the payroll and the purchase order.
  master_accounts: {
    index: editors,
    new: [],
    edit: [],
    delete: [],
  },
  // FIN-1266: the templates of the documents issued every period. Everyone who
  // reads invoices sees them; making, editing and deleting them is accounting's.
  recurring_templates: {
    index: everyone,
    new: admins,
    edit: admins,
    delete: admins,
  },
  // FIN-1244: everyone who reads invoices; what each of them sees is cut by the
  // backend (Vessel.available_to, the Ability rules). Nothing to create or edit on it.
  dashboard: {
    index: everyone,
    new: [],
    edit: [],
    delete: [],
  },
  reports: { index: everyone },
  report_general_ledger: { index: everyone },
  report_budget_performance: { index: everyone },
  report_oal_budget_performance: { index: everyone },
  report_pnl_statement: { index: everyone },
  report_cash_flow_new_statement: { index: everyone },
  report_monthly_budget_performance: { index: everyone },
  report_ship_repair: { index: everyone },
  report_cash_flow: { index: everyone },
  report_cash_flow_statement: { index: everyone },
  report_invoices: { index: everyone },
  report_invoices_budget_items: { index: everyone },
  report_payment_instructions: { index: everyone },
  report_opex: { index: everyone },
  report_not_invoiced_po: { index: everyone },
  report_payrolls: { index: editors },
  report_detailed_delivery: { index: everyone },
  report_open_orders: { index: everyone },
}


const can = (resource, action, role) => {
  if (!permissions[resource]) {
    return false;
  }

  if (!permissions[resource][action]) {
    return false;
  }

  return permissions[resource][action].includes(role);
}

const canView = (resource, role) => {
  return can(resource, "index", role);
}

const canCreate = (resource, role) => {
  return can(resource, "new", role);
}

const canEdit = (resource, role) => {
  return can(resource, "edit", role);
}

const canDelete = (resource, role) => {
  return can(resource, "delete", role);
}

export {
  permissions,
  can,
  canView,
  canCreate,
  canEdit,
  canDelete,
};
